import React, { useEffect, useRef, useState } from 'react'
import { API_URL } from '../../env'
import axios from 'axios'
import { Fade, Zoom } from 'react-awesome-reveal'
import { Accordion, Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faClock, faEnvelope, faFileExcel, faFilePdf, faLocationDot, faPhone, faPlus, faRulerCombined, faSackDollar, faSyncAlt, faUser } from '@fortawesome/free-solid-svg-icons'
import Badge from '../Utils/Badge'
import '../../styles/Admin/AdminPayment.css'
import AccordionItem from '../Utils/AccordionItem'
import Modal from '../Utils/Modal'
import Button from '../Utils/Button'
import { ThreeCircles } from 'react-loader-spinner'
import InputSelect from '../Input/InputSelect'
import InputNumber from '../Input/InputNumber'
import { toast } from 'react-toastify'
import { useLocation, useNavigate } from 'react-router-dom'
import InputSearch from '../Input/InputSearch'
import XLSX from 'xlsx-js-style'

function AdminPayment({ adminRouter, adminRouterPrev, setAdminRouterPrev, itemDisplay, payments, getPayments, diagnostics, getDiagnostics, customers, getCustomers }) {


    const { diagnosticId, customerId } = useLocation().state || {}
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)
    const [accordionIndex, setAccordionIndex] = useState(null)
    const [paymentsDisplay, setPaymentsDisplay] = useState(payments)
    const [displayAddPaymentModal, setDisplayAddPaymentModal] = useState(false)
    const [search, setSearch] = useState("")

    const customerAddRef = useRef(null)
    const [customerAdd, setCustomerAdd] = useState(null)
    const [customerAddError, setCustomerAddError] = useState(null)
    const customerDiagnosticAddRef = useRef(null)
    const [customerDiagnosticAddData, setCustomerDiagnosticAddData] = useState([])
    const [customerDiagnosticAdd, setCustomerDiagnosticAdd] = useState(null)
    const [customerDiagnosticAddError, setCustomerDiagnosticAddError] = useState(null)
    const amountAddRef = useRef(null)
    const [amountAdd, setAmountAdd] = useState("")
    const [amountAddError, setAmountAddError] = useState(null)

    const customerUpdateRef = useRef(null)
    const [customerUpdate, setCustomerUpdate] = useState(null)
    const [customerUpdateError, setCustomerUpdateError] = useState(null)
    const customerDiagnosticUpdateRef = useRef(null)
    const [customerDiagnosticUpdateData, setCustomerDiagnosticUpdateData] = useState([])
    const [customerDiagnosticUpdate, setCustomerDiagnosticUpdate] = useState(null)
    const [customerDiagnosticUpdateError, setCustomerDiagnosticUpdateError] = useState(null)
    const amountUpdateRef = useRef(null)
    const [amountUpdate, setAmountUpdate] = useState("")
    const [amountUpdateError, setAmountUpdateError] = useState(null)

    const customerData = customers.map((item) => { return { value: item.id, label: item.firstname + " " + item.lastname } })
    const paymentsData = payments


    useEffect(() => {

        displayRouterItem()

    }, [])

    useEffect(() => {

        autocompletePaymentAdd()

    }, [customers, diagnostics, itemDisplay])

    useEffect(() => {

        setPaymentsDisplay(payments)

    }, [payments])

    function displayRouterItem() {


        if (itemDisplay === 'addPayment') {
            setDisplayAddPaymentModal(true)
        } else if (itemDisplay !== "0") {
            setAccordionIndex(payments.indexOf(payments.find((item) => item.id === parseInt(itemDisplay))))
            window.scrollTo({ top: 230 + (60 * (payments.indexOf(payments.find((item) => item.id === parseInt(itemDisplay))) - 1)), behavior: 'instant' })
        }

    }

    function autocompletePaymentAdd() {

        if (itemDisplay === 'addPayment') {
            if (customers.find((item) => item)) {
                setCustomerAdd({ value: customers.find((item) => item.id === customerId).id, label: customers.find((item) => item.id === customerId).firstname + " " + customers.find((item) => item.id === customerId).lastname })
                setCustomerAddError(false)
                setCustomerDiagnosticAddData(customers.find((item) => item.id === customerId).diagnostics.map((item) => { return { value: item.id, label: item.type + " (" + item.createdAt + ")" } }))
            }
            if (diagnostics.find((item) => item.id === diagnosticId)) {
                setCustomerDiagnosticAdd({ value: diagnostics.find((item) => item.id === diagnosticId).id, label: diagnostics.find((item) => item.id === diagnosticId).type + " (" + diagnostics.find((item) => item.id === diagnosticId).createdAt + ")" })
                setCustomerDiagnosticAddError(false)
            }
        }

    }

    function exportExcel() {

        const wb = XLSX.utils.book_new()
        let dataTitle = [
            { v: "E5M Diagnostics", s: { font: { name: "Brush Script MT", bold: true, sz: 20, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
        ]
        let dataHeader = [
            { v: "Status", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Date", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Montant", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Diagnostic", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Nom", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Email", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Téléphone", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Adresse", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
        ]
        let dataBody = []
        paymentsDisplay.forEach((item) => {
            dataBody.push([
                { v: item.status, s: { font: { name: "Calibri", sz: 12, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
                { v: item.createdAt, s: { font: { name: "Calibri", sz: 12, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
                { v: item.amount, s: { font: { name: "Calibri", sz: 12, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
                { v: item.diagnostic.type, s: { font: { name: "Calibri", sz: 12, } } },
                { v: item.customer.firstname + " " + item.customer.lastname, s: { font: { name: "Calibri", sz: 12, } } },
                { v: item.customer.email, s: { font: { name: "Calibri", sz: 12, } } },
                { v: item.customer.phone, s: { font: { name: "Calibri", sz: 12, } } },
                { v: item.customer.addressStreet + ", " + item.customer.addressZipcode + " " + item.customer.addressCity }
            ])
        })
        const ws = XLSX.utils.aoa_to_sheet([dataTitle, [], [], dataHeader, ...dataBody])
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 1, c: 7 } }, { s: { r: 2, c: 0 }, e: { r: 2, c: 7 } }]
        ws['!cols'] = [{ wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 30 }]
        XLSX.utils.book_append_sheet(wb, ws, "E5M Diagnostics Sheet1")
        XLSX.writeFile(wb, "E5M Diagnostics Export (" + new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' }) + ").xlsx")

    }

    function addPayment() {

        setIsLoading(true)
        var error = []
        var customerIdFormat = null
        if (customerAdd) {
            customerIdFormat = customerAdd.value
        }
        if (!customerAddRef.current.selectValidation(customerAdd)) {
            error.push("Le client est incorrect")
        }
        var customerDiagnosticIdFormat = null
        if (customerDiagnosticAdd) {
            customerDiagnosticIdFormat = customerDiagnosticAdd.value
        }
        if (!customerDiagnosticAddRef.current.selectValidation(customerDiagnosticAdd)) {
            error.push("Le diagnostic est incorrect")
        }
        var amountFormat = amountAdd
        amountFormat = amountFormat.replace(/ /g, '')
        amountFormat = amountFormat.replace(/€/g, '')
        if (!amountAddRef.current.numberValidation(amountFormat)) {
            error.push("Le montant est incorrect")
        }
        if (error.length > 0) {
            error.map((item) => toast.error(item))
            setIsLoading(false)
        } else {
            const toastId = toast.loading("Ajout...")
            axios.post(API_URL + "payment", {
                amount: amountFormat,
                diagnosticId: customerDiagnosticIdFormat,
                customerId: customerIdFormat
            }).then((response) => {
                if (response.data.message === "PAYMENT_CREATED") {
                    toast.update(toastId, { render: "Paiement ajouté", type: "success", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                    getPayments()
                    getDiagnostics()
                    getCustomers()
                    setCustomerAdd(null)
                    setCustomerAddError(null)
                    setCustomerDiagnosticAddData([])
                    setCustomerDiagnosticAdd(null)
                    setCustomerDiagnosticAddError(null)
                    setAmountAdd("")
                    setAmountAddError(null)
                    setDisplayAddPaymentModal(false)
                }
                setIsLoading(false)
            }).catch((error) => {
                if (error.response) {
                    var errorMessage = error.response.data.message
                    if (errorMessage === "ERROR_DIAGNOSTIC_NOT_FOUND") {
                        errorMessage = "Le diagnostic est introuvable"
                    } else if (errorMessage === "ERROR_CUSTOMER_NOT_FOUND") {
                        errorMessage = "Le client est introuvable"
                    } else if (errorMessage === "ERROR_DIAGNOSTIC_PDF_NOT_FOUND") {
                        errorMessage = "Le fichier PDF du diagnostic est introuvable"
                    } else if (errorMessage === "ERROR_PAYMENT_ALREADY_EXISTS") {
                        errorMessage = "Un paiement est déjà en cours"
                    } else if (errorMessage === "ERROR_PAYMENT_CREATION") {
                        errorMessage = "Erreur lors de la création du paiement"
                    }
                }
                toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                setIsLoading(false)
            })
        }

    }

    return (

        <div id='adminPayment'>
            <Fade direction={adminRouterPrev === 'diagnostic' || adminRouterPrev === 'customer' ? 'right' : 'left'} duration={500} triggerOnce={true}>
                <div className='adminBarButton'>
                    <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPlus} />} text={'Ajouter'} rounded={true} onClick={() => setDisplayAddPaymentModal(true)} />
                    <Button theme={'dark'} icon={<FontAwesomeIcon icon={faFileExcel} />} text={'Exporter'} rounded={true} onClick={() => exportExcel()} />
                    <InputSearch
                        theme={'dark'}
                        type={'payment'}
                        search={search} setSearch={setSearch}
                        data={paymentsData}
                        results={paymentsDisplay} setResults={setPaymentsDisplay}
                        placeholder={'Rechercher par status, date, montant, diagnostic ou client'}
                    />
                </div>
                <Modal
                    displayModal={displayAddPaymentModal}
                    setDisplayModal={setDisplayAddPaymentModal}
                    header={'Ajouter un paiement'}
                    body={
                        <>
                            <InputSelect
                                theme={'dark'}
                                ref={customerAddRef}
                                data={customerData}
                                select={customerAdd} setSelect={setCustomerAdd}
                                selectError={customerAddError} setSelectError={setCustomerAddError}
                                icon={<FontAwesomeIcon icon={faUser} />}
                                placeholder={"Client"}
                                onChange={(value) => setCustomerDiagnosticAddData(customers.find((item) => item.id === value.value).diagnostics.map((item) => { return { value: item.id, label: item.type + " (" + item.createdAt + ")" } }))}
                            />
                            <InputSelect
                                theme={'dark'}
                                ref={customerDiagnosticAddRef}
                                data={customerDiagnosticAddData}
                                select={customerDiagnosticAdd} setSelect={setCustomerDiagnosticAdd}
                                selectError={customerDiagnosticAddError} setSelectError={setCustomerDiagnosticAddError}
                                icon={<FontAwesomeIcon icon={faRulerCombined} />}
                                disabled={itemDisplay !== 'addPayment' && customerDiagnosticAddData.length === 0 ? true : false}
                                placeholder={"Diagnostic"}
                            />
                            <InputNumber
                                type={'amount'}
                                theme={'dark'}
                                ref={amountAddRef}
                                number={amountAdd} setNumber={setAmountAdd}
                                numberError={amountAddError} setNumberError={setAmountAddError}
                                icon={<FontAwesomeIcon icon={faSackDollar} />}
                                placeholder={"Montant"}
                            />
                            <div id='adminInfoAddButton'>
                                {!isLoading ?
                                    <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPlus} />} text={'Ajouter'} rounded={true} onClick={() => addPayment()} />
                                    :
                                    <ThreeCircles visible={true} height={"40"} width={"40"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderDark')} />
                                }
                            </div>
                        </>
                    }
                />
                <Accordion defaultActiveKey={accordionIndex} activeKey={accordionIndex}>
                    {paymentsDisplay.map((item, index) => {
                        return (
                            <AccordionItem
                                key={item.id}
                                indexKey={index}
                                index={accordionIndex}
                                setIndex={setAccordionIndex}
                                header={
                                    <>
                                        <Badge theme={item.status === 'Non payé' ? 'grey' : item.status === 'En cours' ? 'blue' : item.status === 'Payé' ? 'green' : 'red'} text={item.status} />
                                        {item.updatedAt} - {item.amount} ({item.customer.firstname} {item.customer.lastname})
                                    </>
                                }
                                body={
                                    <Row>
                                        <Col>
                                            {item.status === 'Refusé' ?
                                                <Button theme={'primary'} icon={<FontAwesomeIcon icon={faSyncAlt} />} text={'Redemander le paiement'} rounded={true} onClick={() => addPayment()} />
                                                : null
                                            }
                                            <br /><br />
                                            <table className='adminInfo'>
                                                <tbody>
                                                    <tr className='adminInfoText'>
                                                        <td className='adminInfoTextIcon'>
                                                            <FontAwesomeIcon icon={faCalendar} />
                                                        </td>
                                                        <td>
                                                            Créé le {item.createdAt}
                                                        </td>
                                                    </tr>
                                                    <tr className='adminInfoText'>
                                                        <td className='adminInfoTextIcon'>
                                                            <FontAwesomeIcon icon={faCalendar} />
                                                        </td>
                                                        <td>
                                                            Modifié le {item.updatedAt}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <InputSelect
                                                theme={'dark'}
                                                ref={customerUpdateRef}
                                                data={customerData}
                                                select={customerUpdate} setSelect={setCustomerUpdate}
                                                selectError={customerUpdateError} setSelectError={setCustomerUpdateError}
                                                icon={<FontAwesomeIcon icon={faUser} />}
                                                value={{ value: item.customer.id, label: item.customer.firstname + " " + item.customer.lastname }}
                                                disabled={true}
                                                onChange={(value) => setCustomerDiagnosticUpdateData(customers.find((item) => item.id === value.value).diagnostics.map((item) => { return { value: item.id, label: item.type + " (" + item.createdAt + ")" } }))}
                                            />
                                            <InputSelect
                                                theme={'dark'}
                                                ref={customerDiagnosticUpdateRef}
                                                data={customerDiagnosticUpdateData}
                                                select={customerDiagnosticUpdate} setSelect={setCustomerDiagnosticUpdate}
                                                selectError={customerDiagnosticUpdateError} setSelectError={setCustomerDiagnosticUpdateError}
                                                icon={<FontAwesomeIcon icon={faRulerCombined} />}
                                                disabled={true}
                                                value={{ value: item.diagnostic.id, label: item.diagnostic.type + " (" + item.diagnostic.createdAt + ")" }}
                                            />
                                            <InputNumber
                                                type={'amount'}
                                                theme={'dark'}
                                                ref={amountUpdateRef}
                                                number={amountUpdate} setNumber={setAmountUpdate}
                                                numberError={amountUpdateError} setNumberError={setAmountUpdateError}
                                                icon={<FontAwesomeIcon icon={faSackDollar} />}
                                                disabled={true}
                                                placeholder={item.amount}
                                            />
                                        </Col>
                                        <Col>
                                            <Zoom duration={500} delay={100}>
                                                <div className='adminCard' onClick={() => { setAdminRouterPrev(adminRouter); navigate('/administration/diagnostic/' + item.diagnostic.id) }}>
                                                    <div className='adminCardTitle'>
                                                        <FontAwesomeIcon icon={faRulerCombined} className='adminCardTitleIcon' />
                                                        {item.diagnostic.type}
                                                    </div>
                                                    <table>
                                                        <tbody>
                                                            <tr className='adminCardText'>
                                                                <td className='adminCardTextIcon'>
                                                                    <FontAwesomeIcon icon={faClock} />
                                                                </td>
                                                                <td>
                                                                    <Badge theme={item.diagnostic.status === 'En cours' ? 'blue' : item.diagnostic.status === 'Terminé' ? 'green' : 'red'} text={item.diagnostic.status} />
                                                                </td>
                                                            </tr>
                                                            <tr className='adminCardText'>
                                                                <td className='adminCardTextIcon'>
                                                                    <FontAwesomeIcon icon={faCalendar} />
                                                                </td>
                                                                <td>
                                                                    {item.diagnostic.createdAt}
                                                                </td>
                                                            </tr>
                                                            <tr className='adminCardText'>
                                                                <td className='adminCardTextIcon'>
                                                                    <FontAwesomeIcon icon={faFilePdf} />
                                                                </td>
                                                                <td>
                                                                    {item.diagnostic.file}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Zoom>
                                        </Col>
                                        <Col>
                                            <Zoom duration={500} delay={100}>
                                                <div className='adminCard' onClick={() => { setAdminRouterPrev(adminRouter); navigate('/administration/customer/' + item.customer.id) }}>
                                                    <div className='adminCardTitle'>
                                                        <FontAwesomeIcon icon={faUser} className='adminCardTitleIcon' />
                                                        {item.customer.firstname}
                                                        <br />
                                                        {item.customer.lastname}
                                                    </div>
                                                    <table>
                                                        <tbody>
                                                            <tr className='adminCardText'>
                                                                <td className='adminCardTextIcon'>
                                                                    <FontAwesomeIcon icon={faLocationDot} />
                                                                </td>
                                                                <td>
                                                                    {item.customer.addressStreet}, {item.customer.addressZipcode} {item.customer.addressCity}
                                                                </td>
                                                            </tr>
                                                            <tr className='adminCardText'>
                                                                <td className='adminCardTextIcon'>
                                                                    <FontAwesomeIcon icon={faEnvelope} />
                                                                </td>
                                                                <td>
                                                                    {item.customer.email}
                                                                </td>
                                                            </tr>
                                                            <tr className='adminCardText'>
                                                                <td className='adminCardTextIcon'>
                                                                    <FontAwesomeIcon icon={faPhone} />
                                                                </td>
                                                                <td>
                                                                    {item.customer.phone}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Zoom>
                                        </Col>
                                    </Row>
                                }
                                animated={false}
                            />
                        )
                    })}
                </Accordion>
            </Fade>
        </div>

    )

}

export default AdminPayment